function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import Svg from 'ha/ui/next/SvgIcon';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M6 7.749a.75.75 0 0 0 0 1.5h6a.75.75 0 0 0 0-1.5zM9.4 16.249a.241.241 0 0 0 .238-.2 7.961 7.961 0 0 1 .237-.954c.037-.116 0-.345-.332-.345H6a.75.75 0 1 0 0 1.5z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M9.686 19.194a.244.244 0 0 0-.238-.2H3.5a.5.5 0 0 1-.5-.5V5.5a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 .5.5v4.08a.247.247 0 0 0 .3.245 18.173 18.173 0 0 1 2.468-.293.249.249 0 0 0 .232-.25V3.5A1.5 1.5 0 0 0 16.5 2h-4a.241.241 0 0 1-.208-.121 3.827 3.827 0 0 0-6.588 0A.241.241 0 0 1 5.5 2h-4A1.5 1.5 0 0 0 0 3.5v17A1.5 1.5 0 0 0 1.5 22h8.94a.246.246 0 0 0 .207-.379 7.977 7.977 0 0 1-.961-2.427z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M12.244 11.48c.09-.079-.009-.231-.244-.231H6a.75.75 0 0 0 0 1.5h4.958a.241.241 0 0 0 .192-.1 8.059 8.059 0 0 1 1.094-1.169zM17.5 11a6.5 6.5 0 1 0 6.5 6.5 6.508 6.508 0 0 0-6.5-6.5zm1.038 10.178c-.094.023-.288.108-.288.293v.279a.75.75 0 0 1-1.5 0v-.25a.248.248 0 0 0-.248-.248H16a.75.75 0 1 1 0-1.5h2.033a.592.592 0 0 0 .22-1.141l-2.063-.825a2.084 2.084 0 0 1 .344-3.977.335.335 0 0 0 .216-.329v-.228a.75.75 0 0 1 1.5 0v.248a.249.249 0 0 0 .25.249h.5a.75.75 0 0 1 0 1.5h-2.033a.592.592 0 0 0-.22 1.142l2.063.825a2.084 2.084 0 0 1-.272 3.961z"
});

var SvgTaskListCashBold = function SvgTaskListCashBold(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    viewBox: "0 0 24 24"
  }, props), _ref, _ref2, _ref3);
};

export default SvgTaskListCashBold;